import React from "react";
import { 
  LayoutDashboard, 
  Users, 
  FileText, 
  Truck, 
  Car, 
  Calendar, 
  MessageSquare,
  ChevronRight
} from "lucide-react";

var menuItems = [
  { id: "dashboard", label: "Panel General", icon: LayoutDashboard },
  { id: "crm", label: "CRM Comercial", icon: Users },
  { id: "invoices", label: "Presupuestos", icon: FileText },
  { id: "imports", label: "Importaciones", icon: Truck },
  { id: "stock", label: "Stock", icon: Car },
  { id: "calendar", label: "Calendario", icon: Calendar },
  { id: "messages", label: "Mensajes", icon: MessageSquare },
];

function AppSidebar({ currentPage, onNavigate, logoUrl, stats }) {
  return (
    <aside className="w-64 min-h-screen bg-slate-900 flex flex-col" data-testid="app-sidebar">
      {/* Logo */}
      <div className="p-4 border-b border-slate-700">
        <img src={logoUrl} alt="Elite Motor Group" className="h-12 w-auto mx-auto" />
      </div>

      {/* Quick Stats */}
      <div className="p-4 border-b border-slate-700">
        <div className="grid grid-cols-2 gap-2 text-center">
          <div className="bg-slate-800 rounded p-2">
            <p className="text-2xl font-bold text-white">{stats.activeLeads}</p>
            <p className="text-xs text-slate-400">Leads</p>
          </div>
          <div className="bg-slate-800 rounded p-2">
            <p className="text-2xl font-bold text-emerald-400">{stats.inProgress}</p>
            <p className="text-xs text-slate-400">En curso</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-3">
        <ul className="space-y-1">
          {menuItems.map(function(item) {
            var Icon = item.icon;
            var isActive = currentPage === item.id;
            return (
              <li key={item.id}>
                <button
                  onClick={function() { onNavigate(item.id); }}
                  className={"w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all " + 
                    (isActive 
                      ? "bg-blue-600 text-white" 
                      : "text-slate-300 hover:bg-slate-800 hover:text-white")}
                  data-testid={"nav-" + item.id}
                >
                  <Icon size={20} />
                  <span className="flex-1 text-left">{item.label}</span>
                  {isActive && <ChevronRight size={16} />}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-slate-700">
        <p className="text-xs text-slate-500 text-center">
          Elite Motor Group © 2026
        </p>
        <p className="text-xs text-slate-600 text-center mt-1">
          Sistema de Gestión Interno
        </p>
      </div>
    </aside>
  );
}

export default AppSidebar;
